import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfoData", user, 1);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfoData", "");
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js